import api from "@/api";
import { setToken, removeToken } from "@/assets/utils/token";
import routerMapComponents from "@/assets/data/routerMapComponents";
import router from "@/router";
import { Message } from "element-ui";
const user = {
  state: {
    userInfo: {},
    routerList: [],
    loadingState: false,
    lateFlag: false,
    assetsAllData: {},
    asyncRoutestMark: false,
    routeTabs: [],
    nowRouter: "",
    activeUser: {},
    energyType: [],
  },
  mutations: {
    /** 设置用户信息 */
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      if (userInfo) {
        window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      } else {
        window.sessionStorage.removeItem("userInfo");
      }
    },
    /** 获取用户的路由 **/
    SET_ROUTE: (state, list) => {
      state.routerList = list;
      if (list.length !== 0) {
        window.sessionStorage.setItem("routerList", JSON.stringify(list));
      } else {
        window.sessionStorage.removeItem("routerList");
      }
    },
    /** 设置loading状态 **/
    SET_LOADING: (state, status) => {
      state.loadingState = status;
    },
    /** 设置401接口状态 **/
    SET_LATEFLAG: (state, status) => {
      state.lateFlag = status;
    },
    /** 设置资产信息 **/
    SET_ASSETSALLDATA: (state, data) => {
      state.assetsAllData = data;
      if (Object.keys(data).length == 0) {
        window.sessionStorage.removeItem("assetsAllData");
      } else {
        window.sessionStorage.setItem("assetsAllData", JSON.stringify(data));
      }
    },
    /** 设置路由状态 **/
    SET_asyncRoutestMark: (state, status) => {
      state.asyncRoutestMark = status;
    },
    /** 设置路由卡片 **/
    SET_RouteTabs: (state, data) => {
      state.routeTabs = data;
      if (data.length !== 0) {
        window.sessionStorage.setItem("routeTabs", JSON.stringify(data));
      } else {
        window.sessionStorage.removeItem("routeTabs");
      }
    },
    /** 设置当前路由 **/
    SET_NowRouter(state, nowRouter) {
      state.nowRouter = nowRouter;
      window.sessionStorage.setItem("nowRouter", JSON.stringify(nowRouter));
    },
    /** 设置权限管理中点击选择的人员信息 **/
    SET_ACTIVEUSER: (state, status) => {
      state.activeUser = status;
    },
    /** 获取项目的能源类型 **/
    SET_ENERGYTYPE: (state, status) => {
      state.energyType = status;
      window.sessionStorage.setItem("energyType", JSON.stringify(status));
    },
  },
  actions: {
    login({ dispatch, commit, getters }, { username, password }) {
      return new Promise(async (resolve, reject) => {
        try {
          let params = { password };
          if (username.includes("@")) {
            params = Object.assign({ username }, params);
          } else {
            params = Object.assign({ phone: username }, params);
          }
          let result = await api.login(params);
          if (result.status == 200) {
            let { token, refreshToken } = result.data;
            setToken(token, refreshToken);
            dispatch("getUserInfo");
          }
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        router.push({ path: "/login" });
        removeToken();
        router.resetRouter();
        window.sessionStorage.setItem("SidebarStatus", false);
        commit("SET_USER_INFO");
        commit("SET_asyncRoutestMark", false);
        commit("SET_ASSETSALLDATA", {});
        commit("SET_LOADING", false);
        commit("SET_ROUTE", []);
        commit("SET_RouteTabs", []);
        commit("SET_ENERGYTYPE", []);
        resolve();
      });
    },
    getUserInfo({ dispatch, commit, getters }) {
      return new Promise(async (resolve, reject) => {
        try {
          let userInfo = await api.getUser();
          if (userInfo.status == 200) {
            commit("SET_USER_INFO", userInfo.data);
            dispatch("getRouter", userInfo.data.menus);
            // if (!window.sessionStorage.getItem('assetsAllData')) {
            dispatch("getEnergyType", {
              projectId: userInfo.data.projects[0].projectId,
            });
            dispatch("getAsseList", {
              projectId: userInfo.data.projects[0].projectId,
              projectName: userInfo.data.projects[0].projectName,
            });
            // }
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    getRouter({ commit }, menus) {
      if (!menus || menus?.length == 0) {
        Message.error("无页面权限,请联系管理页!");
        commit("SET_LOADING", false);
        return;
      }
      const formatRoutes = function (routes) {
        routes.forEach((route) => {
          if (route.children && route.children.length) {
            formatRoutes(route.children);
          } else {
            route.children = [];
            route.component = routerMapComponents[route.component];
          }
        });
      };
      formatRoutes(menus);
      commit("SET_ROUTE", menus);
    },
    addRouter({ commit }, menus) {
      commit("SET_asyncRoutestMark", true);
      let recursivefilter = (arr) => {
        return arr.filter((item) => {
          if (item.children && item.children.length) {
            item.children = recursivefilter(item.children);
            return item;
          } else {
            return item.path && item.component;
          }
        });
      };
      let newMenus = recursivefilter(menus);
      let setRoute = (list) => {
        list.forEach((v) => {
          if (v.children && v.children.length != 0) {
            setRoute(v.children);
          } else {
            router.addRoute("HomePage", {
              path: v.path,
              name: v.name,
              meta: { title: v.title },
              component: (resolve) =>
                require(["@/views/" + v.component], resolve),
            });
          }
        });
      };
      setRoute(newMenus);
    },
    getAsseList({ commit, state }, { projectId, projectName }) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await api.asseList({
            projectId,
            projectName,
            option: "HasEUDevice",
          });
          if (res && res.status == 200) {
            commit("SET_ASSETSALLDATA", res.data.assets);
            let calleRoute = (list) => {
              let data = list[0];
              if (data.children && data.children.length) {
                calleRoute(data.children);
              } else {
                router.push({ path: data.path });
                Message.success("登录成功");
              }
            };
            calleRoute(state.userInfo.menus);
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    getEnergyType({ commit, state }, { projectId }) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await api.getEnergyTypeByProjectId({
            projectId,
          });
          if (res && res.data.code == 200) {
            commit("SET_ENERGYTYPE", res.data.data);
          } else {
            commit("SET_ENERGYTYPE", [{ key: "power", name: "电" }]);
          }
          resolve();
        } catch (error) {
          commit("SET_ENERGYTYPE", [{ key: "power", name: "电" }]);
          reject(error);
        }
      });
    },
    handleTabs({ commit }, to) {
      if (to?.meta?.title === undefined || to?.meta?.title === null) {
        return;
      }
      let obj = {
        title: to.meta.title,
        path: to.path,
      };
      let routerHistory = window.sessionStorage.getItem("routeTabs")
        ? JSON.parse(window.sessionStorage.getItem("routeTabs"))
        : [];
      routerHistory.push(obj);
      let mapArr = () => {
        let map = new Map();
        for (let item of routerHistory) {
          if (!map.has(item.path)) {
            map.set(item.path, item);
          }
        }
        return [...map.values()];
      };
      let newArr = mapArr();
      // console.log('---handleTabs--to,newArr---',to,newArr)
      newArr = newArr.filter((v) => {
        return v.path != "/login";
      });
      commit("SET_RouteTabs", newArr);
    },
    async handleParameterKey({}, { projectId }) {
      let allKeyArr = require("@/assets/json/telemetry.json").data;
      let res = await api.getDeviceParameter({
        projectId,
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.map((v) => {
          if (v.name) {
            arr.push(v);
          } else {
            let obj = allKeyArr.find((item) => {
              return v.key == item.key;
            });
            if (obj) {
              arr.push(obj);
            }
          }
        });
        return arr;
      }
    },
  },
};
export default user;
